import { FC, ReactNode } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { StorageDocumentLink } from '../../../../components/storage-document-link/index';
import { getS3FileOriginalName } from '../../../../utils/get-s3file-original-name.util';

export type EventDocusignDocPreviewLinksProps = {
  fileLinks: string[];
  onDocumentClick?: (fileLink: string) => void;
  previewMode?: boolean;
};

export const EventDocusignDocPreviewLinks: FC<EventDocusignDocPreviewLinksProps> = ({
  fileLinks,
  onDocumentClick,
}) => {
  if (fileLinks.length === 0) {
    return <span className="truncate text-xs font-[450] text-gray-700">-</span>;
  }

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-2 overflow-hidden">
      {fileLinks.map((fileLink) => (
        <StorageDocumentLink
          key={fileLink}
          label={getS3FileOriginalName(fileLink) || fileLink}
          link={fileLink}
          onDocumentClick={onDocumentClick}
        />
      ))}
    </div>
  );
};

export type EventDocusignDocPreviewRowProps = {
  fileLinks: string[];
  onDocumentClick?: (fileLink: string) => void;
  previewMode?: boolean;
  title?: ReactNode;
};

export const EventDocusignDocPreviewRow: FC<EventDocusignDocPreviewRowProps> = ({
  fileLinks,
  onDocumentClick,
  previewMode,
  title = <AppFormattedMessage id="DOCUSIGN_DOC" />,
}) => {
  if (fileLinks.length === 0) return null;

  return (
    <div className="flex w-full gap-3 border-b-[1px] border-gray-100 py-3 last:border-b-0 last:pb-0">
      <span className="w-[120px] shrink-0 text-xs font-[450] text-gray-500">{title}:</span>
      <div className="min-w-0 flex-1">
        <EventDocusignDocPreviewLinks
          fileLinks={fileLinks}
          onDocumentClick={onDocumentClick}
          previewMode={previewMode}
        />
      </div>
    </div>
  );
};
